import { FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        CreditNotesDetails: action.payload.rows,
        CreditNotesCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
